import React from 'react';
import PropTypes from 'prop-types';
import Feature from "./Feature";
import clsx from "clsx";
import {chileCurrency} from "presentation/common/helpers/utils";

export const Pricing = (props) => {
  const {title, price, items, description, isBestSelling, className} = props;

  return (
    <div
      className={clsx("relative p-8 pt-6 bg-white border border-gray-200 rounded-2xl shadow-sm flex flex-col", {'lg:shadow-2xl transform lg:scale-110 z-10': isBestSelling}, className)}>
      <div className="flex-1">
        <h3 className="text-xl font-semibold text-primary">{title}</h3>

        {
          isBestSelling &&
          <p
            className="absolute top-0 py-1.5 px-4 bg-primary rounded-full text-xs font-semibold uppercase tracking-wide text-white transform -translate-y-1/2">
            Más Vendido
          </p>
        }

        <p className="mt-2 flex items-baseline text-gray-900">
          <span className="text-3xl font-extrabold tracking-tight">{chileCurrency(price)}</span>
          {/*<span className="ml-1 text-xl font-semibold">/{priceInterval}</span>*/}
        </p>

        <p className="mt-6 text-gray-500">{description}</p>

        <ul className="mt-4 space-y-2">
          {
            items.map(item => <Feature title={item.title} key={item.id}/>)
          }
        </ul>
      </div>

      {props.children}
    </div>
  );
};

Pricing.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  price: PropTypes.string.isRequired,
  priceInterval: PropTypes.string,
  items: PropTypes.array,
  isBestSelling: PropTypes.bool
}

Pricing.defaultProps = {
  description: '',
  items: [],
  priceInterval: "mensual",
  isBestSelling: false
}

export default Pricing;
